import { useTranslation } from 'react-i18next'
import BrandSection from './components/BrandSection'
import ContactSection from './components/ContactSection'
import Breadcrumb from '@/components/feature/Breadcrumb'
import SEOHead from '@/components/feature/SEOHead'

export default function AboutPage() {
  const { t } = useTranslation('common')

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '快猫短视频',
        url: 'https://kuaikuaimao.com',
        description: t('footer.brandDesc'),
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: t('footer.phone'),
          contactType: 'customer service',
          email: t('footer.email'),
        },
        address: {
          '@type': 'PostalAddress',
          streetAddress: t('footer.address'),
          addressCountry: 'CN',
        },
      },
      {
        '@type': 'WebPage',
        name: '关于快猫短视频',
        description: t('about.subtitle'),
        url: 'https://kuaikuaimao.com/about',
        isPartOf: { '@type': 'WebSite', name: '快猫短视频' },
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: t('breadcrumb.home'), item: 'https://kuaikuaimao.com' },
          { '@type': 'ListItem', position: 2, name: t('about.title') },
        ],
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '快猫短视频怎么玩？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '下载快猫短视频APP后，注册账号即可开始浏览各类短视频内容。你可以通过分类导航找到感兴趣的内容，点赞、评论、分享你喜欢的视频，也可以自己拍摄上传原创视频加入创作者社区。',
            },
          },
          {
            '@type': 'Question',
            name: '如何成为快猫短视频创作者？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '在快猫短视频APP中点击发布按钮，上传你的原创视频内容即可成为创作者。平台为创作者提供流量扶持和收益分成，优质内容将获得更多推荐机会。',
            },
          },
          {
            '@type': 'Question',
            name: '快猫短视频支持哪些平台？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '快猫短视频支持iOS和Android系统的智能手机和平板设备，可在各大应用商店搜索"快猫短视频"免费下载。',
            },
          },
          {
            '@type': 'Question',
            name: '快猫短视频的内容是否免费？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '是的，快猫短视频平台上的所有内容均为免费观看。用户可以无限次浏览各种类型的短视频内容，无需任何付费。',
            },
          },
        ],
      },
    ],
  }

  return (
    <>
      <SEOHead
        title="关于我们"
        description="快快猫短视频成立于2024年，专注于短视频内容创作与分发。了解快猫短视频的品牌故事、核心价值观和联系方式，加入千万用户的短视频社区。"
        keywords="快猫短视频,关于快猫短视频,快猫短视频品牌,短视频平台介绍,联系我们"
        canonicalUrl="https://kuaikuaimao.com/about"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <main className="pt-20 md:pt-24">
        <div className="mx-auto px-4 md:px-6 max-w-7xl">
          <Breadcrumb
            items={[
              { label: t('breadcrumb.home'), path: '/' },
              { label: t('about.title') },
            ]}
          />
        </div>
        <BrandSection />
        <ContactSection />
      </main>
    </>
  )
}